import { mulDivVariantConfig } from '../core/rulesMulDivConfig';
import {
  type RulesMulDivFlag,
  createRulesMulDivProblemState,
  populateRulesMulDivProblems,
} from '../core/rulesMulDivProblems';

import {
  type RulesGame,
  type UseRulesFamilyGameOptions,
  useRulesBoardGame,
} from './useRulesBoardGame';

export type UseMulDivGameOptions = UseRulesFamilyGameOptions<RulesMulDivFlag>;

/**
 * Progression, pacing and problem selection for a VIF multiplication/division
 * variant. A thin wrapper around the family-generic `useRulesBoardGame`,
 * supplying mul/div's config/problem-selection plumbing; see that hook's own
 * doc comment for the shared mechanics (layers/games/rounds, the countdown,
 * the layer-transition wipe, the "begin board" lifecycle).
 *
 * Covers all sixteen `VIFRulesMulDiv` flags, including 6/7/8 ("Auditory
 * Memory").
 */
export function useMulDivGame(options: UseMulDivGameOptions): RulesGame {
  return useRulesBoardGame({
    ...options,
    resolveConfig: mulDivVariantConfig,
    createProblemState: createRulesMulDivProblemState,
    populateProblems: populateRulesMulDivProblems,
  });
}
